export const getStatusName = (status: string) => {
    if (status === undefined) return "Não encontrado"

    if(status.includes(' - ')) {
        const parts = status.split(' - ');
        return parts[0];
    }
    return "Não encontrado"
}